import React, { useState, useEffect } from "react";
import HotelsTable from "./OrdersTable/HotelsTable/HotelsTable";
import PackageTable from "./OrdersTable/PackageTable/PackageTable";
import OrdersFilters from "./OrdersFilters";
import {
  getOrdersByEmail,
  cancelOrderByOrderId,
  getLDSOrders,
} from "../../services/fhpService";
import { Loader } from "../Loader/Loader";

// CSS
import "./Orders.css";

// Languages
import { getDynamicOrders } from "../../services/dynamicService";
import DynamicPackageTable from "./OrdersTable/DynamicTable/DynamicTable";
import { Pagination } from "antd";

const Orders = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [orders, setOrders] = useState(null);
  const [filteredOrders, setFilteredOrders] = useState(null);
  const [currentTabIndex, _setCurrentTabIndex] = useState(0);
  const [dynamicFilters, setDynamicFilters] = useState({});

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(5);
  const [total, setTotal] = useState(0);

  const getHotelsFromServer = async (page, size) => {
    const agentEmail = JSON.parse(localStorage.getItem("UserInfo")).email;
    let ordersData = await getOrdersByEmail({
      email: agentEmail,
    });
    return ordersData?.data?.orders;
  };

  const getPackgesFromServer = async () => {
    const agentId = JSON.parse(localStorage.getItem("UserInfo")).id;
    const res = await getLDSOrders(agentId, "FlightsHotel");
    return res?.data;
  };

  const getDynamicPackagesFromServer = async (page, size, filters = {}) => {
    const agentId = JSON.parse(localStorage.getItem("UserInfo")).id;
    const requestData = {
      agent_id: agentId,
      page: page,
      size: size,
      ...filters, // Include server-side filters
    };

    const res = await getDynamicOrders(requestData);

    setPage(res?.data?.page || 1);
    setSize(res?.data?.page_size || 5);
    setTotal(res?.data?.total || 0);
    return res?.data?.orders || [];
  };

  const setCurrentTabIndex = (index) => {
    _setCurrentTabIndex(index);
    setPage(1); // Reset page when changing tabs
    setSize(5); // Reset size when changing tabs
    setOrders(null); // Clear orders when changing tabs
    setFilteredOrders(null); // Clear filtered orders when changing tabs
    setDynamicFilters({}); // Clear dynamic filters when changing tabs
  };

  const handleDynamicFilterChange = (filters) => {
    setDynamicFilters(filters);
    setPage(1); // Reset to first page when filters change
    setOrders(null); // Clear orders to trigger reload with new filters
  };

  const loadOrders = (page, pageSize) => {
    if (isLoading) return;
    const fetchFunc = TABS[currentTabIndex].fetchFunc;
    setIsLoading(true);

    if (fetchFunc) {
      // For dynamic packages, pass the filters
      const promise =
        currentTabIndex === 3
          ? fetchFunc(page, pageSize, dynamicFilters)
          : fetchFunc(page, pageSize);

      promise.then((res) => {
        setOrders(res);
        setFilteredOrders(res);
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setOrders(null);
  }, [currentTabIndex]);

  useEffect(() => {
    if (orders !== null) return;
    loadOrders();
  }, [orders]);

  const cancelOrder = async ({ orderId, segmentId }) => {
    await cancelOrderByOrderId({ orderID: orderId, segmentId });
    loadOrders();
  };

  const TABS = [
    {
      index: 0,
      component: (
        <HotelsTable
          allOrders={orders}
          setOrders={setOrders}
          orders={filteredOrders}
          cancelOrder={cancelOrder}
        ></HotelsTable>
      ),
      fetchFunc: getHotelsFromServer,
    },
    { index: 1, component: <div>בבנייה</div> },
    {
      index: 2,
      component: (
        <PackageTable
          orders={filteredOrders}
          allOrders={orders}
          setOrders={setOrders}
        />
      ),
      fetchFunc: getPackgesFromServer,
    },
    {
      index: 3,
      component: (
        <DynamicPackageTable
          orders={filteredOrders}
          allOrders={orders}
          setOrders={setOrders}
          cancelOrder={cancelOrder}
        />
      ),
      fetchFunc: getDynamicPackagesFromServer,
    },
  ];

  return (
    <div className="orders-table-wrapper lg:tw-pt-10 lg:tw-pb-10">
      <OrdersFilters
        isLoading={isLoading}
        orders={orders}
        currentTabIndex={currentTabIndex}
        setCurrentTabIndex={setCurrentTabIndex}
        setFilteredOrders={setFilteredOrders}
        onDynamicFilterChange={handleDynamicFilterChange}
      />
      <div className="orders">
        {isLoading ? (
          <div
            style={{
              height: "50vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader />
          </div>
        ) : !filteredOrders?.length ? (
          <div className="no-data">אין הזמנות</div>
        ) : (
          TABS[currentTabIndex].component
        )}
      </div>
      {total ? (
        <Pagination
          pageSizeOptions={[5, 10, 20, 50]}
          pageSize={size}
          current={page}
          total={total}
          onChange={(page, pageSize) => {
            setPage(page);
            setSize(pageSize);
            // For dynamic packages, we need to call loadOrders to include filters
            if (currentTabIndex === 4) {
              loadOrders(page, pageSize);
            } else {
              loadOrders(page, pageSize);
            }
          }}
          style={{
            direction: "rtl",
          }}
        />
      ) : null}
    </div>
  );
};

export default Orders;
